import {
  Alert,
  Box,
  Button,
  Container,
  IconButton,
  Snackbar,
  Typography,
} from "@mui/material";
import { Colors } from "helpers/Consts";
import { useDispatch, useSelector } from "react-redux";
import { IProfileUpdateParams } from "types/Profile";
import { setEditedProfile } from "redux/Actions";
import { useMutationEditProfile } from "services/api/mutations/useMutationEditProfile";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { ArrowBackIos } from "@mui/icons-material";
import { useQueryAddresses } from "services/api/queries/useQueryAddresses";
import SingleAddressCard from "components/SingleAddressCard";
import { IUserAddressInfo } from "types/Address";
import { Link, useSearchParams } from "react-router-dom";
import CreateAddressDialog from "dialogs/CreateAddressDialog";
import { ICardapioAppState } from "../../redux/RootReducer";
import { UseQueryResult } from "react-query";
import { IShoppingBagData } from "../../types/ShoppingBag";
import { getSearchParams } from "../../helpers/Utils";

type Props = {
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
}

function Addresses({shoppingBagQuery}: Props) {

  const [searchParams] = useSearchParams();
  const placeId = searchParams.get("place_id");
  const customOriginQrCode = searchParams.get("origin")
  const table = searchParams.get("table");
  const params = getSearchParams(placeId!, table, customOriginQrCode)



  const [open, setOpen] = useState<boolean>(false);
  const [openCreateAddressDialog, setOpenCreateAddressDialog] =
    useState<boolean>(false);
  const [mensagem, setMensagem] = useState<string>("");
  const loginInfo = useSelector((state: ICardapioAppState) => state?.loginInfo);
  const apiAddresses = useQueryAddresses(loginInfo?.id ?? -1);
  const dispatch = useDispatch();
  const phoneRegExp =
    /^\s*(\d{2}|\d{0})[-. ]?(\d{5}|\d{4})[-. ]?(\d{4})[-. ]?\s*$/;
  const { mutate: editProfile  } =
    useMutationEditProfile();
  const formik = useFormik({
    initialValues: {
      id: loginInfo!.id,
      name: loginInfo?.name ?? "",
      phone_number: loginInfo?.phone_number ?? "",
    } as IProfileUpdateParams,
    validationSchema: Yup.object().shape({
      phone_number: Yup.string()
        .matches(phoneRegExp, "Telefone não é valido.")
        .required("Nome é obrigatório."),
      name: Yup.string()
        .min(3, "Problema no nome")
        .required("Telefone é obrigatório."),
    }),
    enableReinitialize: true,
    onSubmit: async (values: any) => {
      editProfile(values);
      loginInfo!.name = values.name;
      loginInfo!.phone_number = values.phone_number;
      dispatch(setEditedProfile(loginInfo));
      localStorage.setItem("loginInfo", JSON.stringify(loginInfo));
      formik.setSubmitting(false);
      setMensagem("Perfil Editado com Sucesso");
      setOpen(true);
    },
  });

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleCloseCreateAddressDialog = () => {
    setOpenCreateAddressDialog(false);
  };

  return (
    <Container sx={{ height: "100vh" }} maxWidth="lg">
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      >
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          {mensagem}
        </Alert>
      </Snackbar>
      {loginInfo && <CreateAddressDialog
        handleClose={handleCloseCreateAddressDialog}
        open={openCreateAddressDialog}
        loginInfo={loginInfo}
        shoppingBagQuery={shoppingBagQuery}
      />}
      <Box display="flex" alignItems="center">
        <Box component={Link} to={`/settings${params}`}>
          <IconButton color="primary" onClick={handleClose}>
            <ArrowBackIos fill={Colors.orangePrimary} />
          </IconButton>
        </Box>
        <Box
          flexGrow={1}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            fontSize="18px"
            fontWeight={"400"}
            color={Colors.orangePrimary}
          >
            Meus Endereços ({apiAddresses.data?.data.length})
          </Typography>
        </Box>
      </Box>
      <Box p={2}>
        <Box>
          <Button
            fullWidth
            variant="outlined"
            color="inherit"
            sx={{
              borderStyle: "dashed",
              marginTop: { md: 3 }
            }}
            onClick={() => setOpenCreateAddressDialog(true)}
          >
            + Adicionar Endereço
          </Button>
        </Box>
        <Box
          sx={{
            marginTop: "10px",
          }}
        >
          {apiAddresses.data?.data
            .filter((end) => end.visible)
            .map((end: IUserAddressInfo) => (
              <SingleAddressCard
                singleItem={end}
                key={end.id}
                shoppingBagQuery={shoppingBagQuery}
              />
            ))}
        </Box>
      </Box>
    </Container>
  );
}

export default Addresses;
